<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="站点基本信息" name="base"></el-tab-pane>
            <el-tab-pane label="SEO信息" name="seo"></el-tab-pane>
        </el-tabs>
        <el-form ref="form" :model="form" :rules="rules" label-width="160px" style="width: 600px;">
            <div v-if="activeName === 'base'">
                <el-form-item label="站点名称" prop="siteName">
                    <el-input v-model="form.siteName" placeholder="请输入站点名称"></el-input>
                </el-form-item>
                <el-form-item label="URL识别地址" prop="siteUrl">
                    <div>   
                        <el-input v-model="form.siteUrl" placeholder="请输入URL识别地址，如：uk、us、eu"></el-input>
                        <div style="color: #999;">
                            请使用英文字母简写，用于区分不同地区站点
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="隐私政策链接" prop="privacyPolicyUrl">
                    <div>   
                        <el-input v-model="form.privacyPolicyUrl" placeholder="请输入隐私政策链接"></el-input>
                        <!-- <div style="color: #999;">
                            请使用英文字母简写，用于区分不同地区站点
                        </div> -->
                    </div>
                </el-form-item>
                <el-form-item label="logo 跳转的URL" prop="logoUrl">
                    <div>   
                        <el-input v-model="form.logoUrl" placeholder="请输入logo 跳转的URL"></el-input>
                        <!-- <div style="color: #999;">
                            请使用英文字母简写，用于区分不同地区站点
                        </div> -->
                    </div>
                </el-form-item>
                <el-form-item label="用户协议链接" prop="userAgreementUrl">
                    <div>   
                        <el-input v-model="form.userAgreementUrl" placeholder="请输入用户协议链接"></el-input>
                        <!-- <div style="color: #999;">
                            请使用英文字母简写，用于区分不同地区站点
                        </div> -->
                    </div>
                </el-form-item>
                <el-form-item label="ga埋点" prop="gaPoint">
                    <div>   
                        <el-input v-model="form.gaPoint" placeholder="请输入ga埋点"></el-input>
                        <!-- <div style="color: #999;">
                            请使用英文字母简写，用于区分不同地区站点
                        </div> -->
                    </div>
                </el-form-item>
                <el-form-item label="教学视频" prop="teachingVideoUrl">
                    <uploader-video v-model="form.teachingVideoUrl"></uploader-video>
                </el-form-item>
                <el-form-item label="千分位开关" prop="isThousandths">
                    <el-radio-group v-model="form.isThousandths">
                        <el-radio :label="0" :value="0">关</el-radio>
                        <el-radio :label="1" :value="1">开</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div v-else>
                <el-form-item label="Title（标题）" prop="seoTitle">
                    <el-input v-model="form.seoTitle" placeholder="请输入页面标题"></el-input>
                </el-form-item>
                <el-form-item label="Description（描述）" prop="seoDescription">
                    <el-input type="textarea" v-model="form.seoDescription" placeholder="请输入页面描述"></el-input>
                </el-form-item>
                <el-form-item label="Keywords（关键词）" prop="seoKeywords">
                    <el-input v-model="form.seoKeywords" placeholder="请输入关键词，多个关键词用逗号分隔"></el-input>
                </el-form-item>
            </div>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
// import { add, edit, detail, countryList } from "@/api/language";
import { add, edit ,detail} from "@/api/site";
// import { upload } from "@/api/upload";
import UploaderVideo from "@/components/UploaderVideo.vue";
export default {
    components: { UploaderVideo },
    data() {
        return {
            activeName: "base",
            id: null,
            form: {
                siteName: "",
                siteUrl: "",
                userAgreementUrl: "",
                privacyPolicyUrl: "",
                logoUrl: "",
                isThousandths:0,
                teachingVideoUrl:'',
                gaPoint:''
            },
            countries: [],
            rules: {
                siteName: [{ required: true, message: '请输入站点名称' }],
                siteUrl: [{ required: true, message: '请输入URL识别地址' }],
                privacyPolicyUrl: [{ required: true, message: '请输入隐私政策链接' }],
                userAgreementUrl: [{ required: true, message: '请输入用户协议链接' }],
                gaPoint: [{ required: true, message: '请输入ga埋点' }],
                logoUrl: [{ required: true, message: '请输入logo 跳转的URL' }],
                teachingVideoUrl: [{ required: true, message: "请上传视频", trigger: "change" }]
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
        // this.getCountryList();
    },
    methods: {
        getCountryList() {
            // countryList().then(({ code, data, message }) => {
            //     if (code == 200) {
            //         this.countries = data;
            //     } else {
            //         this.$message.error(message);
            //     }
            // })
        },
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {
                        siteName: data.siteName,
                        siteUrl: data.siteUrl,
                        privacyPolicyUrl: data.privacyPolicyUrl || '',
                        logoUrl: data.logoUrl || '',
                        gaPoint: data.gaPoint || '',
                        userAgreementUrl: data.userAgreementUrl || '',
                        isThousandths:data.isThousandths || 0,
                        teachingVideoUrl:data.teachingVideoUrl || '',
                        seoTitle: data.seoTitle,
                        seoDescription: data.seoDescription,
                        seoKeywords: data.seoKeywords
                    };
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>